const FIRST_TOUCH_KEY = 'bnph_attr';
const PAGES_KEY = 'bnph_pages';
const SESSION_KEY = 'bnph_sid';

const safe = (fn, fallback) => {
  try { return fn(); } catch { return fallback; }
};

const uuid = () => (window.crypto?.randomUUID ? window.crypto.randomUUID() : `${Date.now()}-${Math.random().toString(36).slice(2)}`);

export const newSubmissionId = uuid;

export const getSessionId = () => safe(() => {
  let id = sessionStorage.getItem(SESSION_KEY);
  if (!id) { id = uuid(); sessionStorage.setItem(SESSION_KEY, id); }
  return id;
}, 'unknown');

// Capture first-touch landing page, referrer and campaign params once per session
export const initAttribution = () => safe(() => {
  if (sessionStorage.getItem(FIRST_TOUCH_KEY)) return;
  const params = new URLSearchParams(window.location.search);
  const data = { landing_page: window.location.pathname, referrer: document.referrer || null, gclid: params.has('gclid') || params.has('gbraid') || params.has('wbraid') };
  ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content'].forEach((k) => {
    if (params.get(k)) data[k] = params.get(k).slice(0, 150);
  });
  sessionStorage.setItem(FIRST_TOUCH_KEY, JSON.stringify(data));
});

export const recordPage = (path) => safe(() => {
  const pages = JSON.parse(sessionStorage.getItem(PAGES_KEY) || '[]');
  if (pages[pages.length - 1] !== path) pages.push(path);
  sessionStorage.setItem(PAGES_KEY, JSON.stringify(pages.slice(-25)));
});

export const getAttribution = () => safe(() => ({
  ...JSON.parse(sessionStorage.getItem(FIRST_TOUCH_KEY) || '{}'),
  pages_visited: JSON.parse(sessionStorage.getItem(PAGES_KEY) || '[]'),
}), { pages_visited: [] });

// GA4 events: never include personal information
export const trackEvent = (name, params = {}) => {
  if (typeof window.gtag === 'function') window.gtag('event', name, params);
};
